import { useMediaQuery } from "./useMediaQuery";

/**
 * usePrefersReducedMotion
 *
 * Returns true when the user has requested reduced motion. It also returns
 * true during SSR and before the first client media-query evaluation so
 * motion never starts before the user's preference is known.
 */
export const usePrefersReducedMotion = (): boolean => {
  return useMediaQuery("(prefers-reduced-motion: reduce)") ?? true;
};
